// extracted by mini-css-extract-plugin
export default {"loading":"ProgressiveImage_loading__ZXOzw","loaded":"ProgressiveImage_loaded__eTYuO"};